export const profile = {
  personalInfo: "Personal Information",
  fullName: "Full Name",
  email: "Email Address",
  createdAt: "Creation Date",
  editTitle: "Edit Personal Information",

  // BankInfoTab
  addBank: "Add Bank",
  selected: "Selected",
  bankName: "Bank Name",
  iban: "IBAN",
  bic: "BIC",
  rib: "RIB",
  notProvided: "Not Provided",

  // CompanyDetails
  companyInfo: "Company Information",
  companyName: "Company Name",
  ownerName: "Owner",
  companyEmail: "Company Email",
  phone: "Phone",
  address: "Address",
  paymentMethod: "Payment Method",
  noPaymentMethod: "No payment method defined.",
  note: "Note",
  noNote: "No note has been added yet.",
  companyDocuments: "Company Documents",
  viewDownload: "View / Download",
  kbis: "KBIS",
  urssaf: "URSSAF",
  fiscale: "Fiscal Document",
  rcPro: "Professional RC",
  extraFile: "Extra File",
  noDocuments: "No documents available.",

  // PackInfoTab
  packInfo: "Pack Information",
  packName: "Pack Name",
  description: "Description",
  price: "Price",
  duration: "Duration",
  status: "Status",
  active: "Active",
  inactive: "Inactive",
  timeLeft: "Time Left",
  expired: "Expired",
  notAvailable: "Not Available",
  urgent: "Urgent",

  // CompanyConfig specific
  tabs: {
    info: "Information",
    bank: "Bank",
    pack: "Pack",
  },
  loadingUser: "Loading user...",
  errorUser: "Error loading user",
  loadingBanks: "Loading banks...",
  errorBanks: "Error loading banks",
  noBanks: "No bank information available",
  deleteConfirmation: "Are you sure you want to delete this bank?",
  deleteWarningTitle: "Warning",
  deleteWarningMessage:
    "You are trying to delete the selected bank! Please select another bank first before deleting it.",
  close: "Close",
  enabled: "Enabled",
  disabled: "Disabled",
};
